<template>
  <div class="home">
    <!-- main section -->
    <v-flex xs12>
      <v-card class="pa-5 cover-background">
        <v-responsive :aspect-ratio="16/4.3">
          <v-card-title primary-title>
            <v-card-text>
              <h1 class="display-3 mb-0 text-lg-center white--text">Free Best Stock Images</h1>
            </v-card-text>
          </v-card-title>

          <v-form v-on:submit.prevent="search_img">
            <v-layout row wrap>
              <v-flex lg6 offset-lg3>
                <v-text-field
                  required
                  v-model="search_image"
                  light
                  label="Search..."
                  color="blue"
                  solo
                  append-icon="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>

          <v-card-actions>
            <v-card-text class="text-lg-center">
              <v-chip
                label
                color="blue darken-3"
                text-color="white"
                v-for="catagory in img_catagories"
                v-bind:key="catagory"
                v-on:click="searchByCatg(catagory)"
                style="cursor:pointer"
              >{{ catagory }}</v-chip>
            </v-card-text>
          </v-card-actions>
        </v-responsive>
      </v-card>
    </v-flex>

    <!-- images cards -->
    <v-flex xs12 class="mt-2">
      <v-card>
        <v-container grid-list-sm fluid>
          <v-layout row wrap>
            <v-flex v-for="n in fetch_imgs" :key="n.id" lg3 md4 sm6 xs12 d-flex class="pa-1">
              <v-card class="pa-1 imginfo-card">
                <v-layout row wrap class="img-card">
                  <v-img
                    :src="imgSmallSize(n.webformatURL)"
                    aspect-ratio="1.5"
                    class="grey lighten-2"
                    v-on:click="viewimagebyurl(n.largeImageURL)"
                  >
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                  <!-- img info tool -->
                  <img-info
                    :user="n.user"
                    :userImg="n.userImageURL"
                    :imgWFURL="n.webformatURL"
                    :id="n.id"
                  ></img-info>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImgInfo from "./tools/ImgInfo.vue";
export default {
  name: "home",
  components: {
    ImgInfo
  },
  data() {
    return {
      search_image: "",
      img_catagories: [
        "nature",
        "backgrounds",
        "science",
        "education",
        "people",
        "places",
        "animals",
        "industry",
        "computer",
        "sports",
        "music"
      ]
    };
  },
  computed: {
    ...mapGetters(["fetch_imgs"])
  },
  mounted() {
    if (this.fetch_imgs.length <= 0) {
      this.$store.dispatch("fetchImages");
    }
  },

  methods: {
    viewimagebyurl: function(imgUrl) {
      var url = imgUrl.split("/")[4].split("_")[0];
      this.$router.push({ path: `/viewimage/${url}` });
    },
    search_img: function() {
      this.$router.push({ path: `/search/${this.search_image}` });
    },
    searchByCatg: function(catagory) {
      this.$router.push({ path: `/search/${catagory}` });
    },
    imgSmallSize: function(imgUrlWF) {
      var img_id = imgUrlWF.split("/")[4].split("_")[0];
      return `https://pixabay.com/get/${img_id}_340.jpg`;
    }
  }
};
</script>

<style>
* {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
 .v-card__text span.v-chip:hover{
  background:rgba(32, 110, 212, 0.508) !important;
 }
.imginfo-card{
  cursor: pointer !important;
   
}
.cover-background {
  background-image: url("../assets/back.jpg") !important;
  background-size: cover;
}
</style>
